<template>
    <div>
        <ejs-grid ref="supplierGrid" :dataSource="suppliers" :allowPaging="true" :allowSorting='true' :sortSettings='sortOptions' :pageSettings='pageSettings' 
                                    :enablePersistence='false' :allowExcelExport='true' :allowReordering='true' :allowResizing='true'>
            <e-columns>
                <e-column field='name' headerText='Fournisseur'  width=20></e-column>
                <e-column field='num' headerText='Numéro' width=20></e-column>
                <e-column field='contactNames' headerText='Contact' width=20></e-column>
                <e-column field='commands' headerText='' textAlign="center" width=20  :commands="commands"></e-column>
            </e-columns>
        </ejs-grid>

        <!-- modal de suppression d'un fournisseur -->
        <modal :show.sync="deleteModal" headerClasses="justify-content-center">
            <h4 slot="header">{{supplierName}}</h4>
            <h4 class="text-center mt-0">
                Etes vous sûre de vouloir le <br>
                supprimer?<br>
                (Cette action est définitive et <br>
                irréversible)
            </h4>
            <div class="row justify-content-around">
                <button class="col-5 btn btn-sm btn-primary radius" @click="backToList()">Annuler</button>
                <button class="col-5 btn btn-sm btn-suppr radius" @click="deleteSupplier()">Supprimer</button>
            </div>
        </modal>
    </div>
</template>
<script>
import { Modal } from 'src/components'
import { GridPlugin, Page, Sort, Search, ExcelExport, Reorder, Resize, CommandColumn} from "@syncfusion/ej2-vue-grids";

    export default {
        name: 'SupplierList',
        components:{
            Modal,
        },
        data(){ 
            return {
                deleteModal: false,
                supplierId: '',
                supplierName: '',
                suppliers: [],
                contactNames: [],

                pageSettings: { pageSizes: [10, 20, 50] , pageSize: 10  },

                sortOptions: { columns: [{ field: 'name', direction: 'Ascending' }] },
                
                commands: [
                    { buttonOption: { cssClass: 'e-flat', iconCss: 'fa fa-edit', click: this.editButton} },
                    { buttonOption: { cssClass: 'e-flat', iconCss: 'fa fa-trash-alt', click: this.deleteButton} },
                ],
            }
        },
        provide: {
            grid: [Page, Sort, Search, ExcelExport, Reorder, Resize, CommandColumn]
        },
        beforeDestroy(){
            // Sauvegarde la configuration du tableau dans le localStorage
            var grid = this.$refs.supplierGrid.ej2Instances;
            localStorage.setItem('supplierGrid', (grid.getPersistData()));
        },
        mounted() {
            // Remplir "suppliers" avec un appel GET Axios
            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/supplier/list`).then((response) => {
                this.suppliers = response.data
            
                this.suppliers.forEach( supplier => {
                    var contactList = ''
                    supplier.contacts.forEach(contact => {
                        contactList += contact.name +', '
                    })
                    contactList = contactList.slice(0, -2)

                    supplier.contactNames = contactList
                })
            })

            this.getPersistentSettings('supplierGrid')

        },
        methods: {

            backToList() {
                this.deleteModal = false
            },

            getPersistentSettings(ref){
                if(localStorage.getItem(ref) !== null){
                    var grid = this.$refs[ref].ej2Instances;

                    var model = (localStorage.getItem(ref))
                    var modelParsed = JSON.parse(model);

                    var newColumns= [];
                    var cookieColumns = modelParsed.columns;
                    var actualColumns = grid.columns;

                    cookieColumns.forEach(cookieColumn => {
                    actualColumns.forEach(actualColumn => {
                        if(actualColumn.index == cookieColumn.index){
                        actualColumn.visible = cookieColumn.visible;
                        newColumns.push(actualColumn)
                        }
                    })
                    })

                    grid.columns = newColumns;
                    grid.sortSettings = modelParsed.sortSettings;
                    grid.pageSettings.currentPage = modelParsed.pageSettings.currentPage
                }
            },

            editButton(args){
                var rowEle = $(args.target).parents('.e-row')
                var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
                this.$refs.supplierGrid.selectRow(rowIndex)
                var rowData = this.$refs.supplierGrid.getSelectedRecords()[0]
                this.$router.push({ name: 'supplier form', params: { id: rowData.id }})
            },

            deleteButton(args){
                var rowEle = $(args.target).parents('.e-row')
                var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
                this.$refs.supplierGrid.selectRow(rowIndex)
                var rowData = this.$refs.supplierGrid.getSelectedRecords()[0]
                this.supplierId = rowData.id
                this.supplierName = rowData.name
                this.deleteModal = true
                
            },

            deleteSupplier(){
                const index = this.suppliers.findIndex(supplier => supplier.id === this.supplierId)
                this.axios.post(process.env.VUE_APP_API_BASE_URL + `supplier/delete/` + this.supplierId).then((response => {
                    this.$notify({ message: 'Le fournisseur et ses contacts ont bien été supprimé', type: "success", verticalAlign: "bottom" })
                    this.suppliers.splice(index,1)
                    this.$refs.supplierGrid.refresh()
                })).catch( error => {
                    this.$notify({ message: 'Le fournisseur est utilisé dans une fiche et ne peut pas être supprimé', type: "danger", verticalAlign: "bottom" })   
                }) 
                this.deleteModal = false
                         
            },

            // Permet de faire une recherche dans le tableau
            search: function() {
                let searchText = document.getElementsByClassName('MySearch')[0].value;
                this.$refs.supplierGrid.search(searchText);
            },

            excelExport: function() {
                
                this.$refs.supplierGrid.excelExport();
                
            }

        },
    }
</script>